var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100",attrs:{"id":"common-video"}},[_c('div',{staticClass:"h-100"},[_c('video',{ref:"myVideo",staticClass:"video-box",attrs:{"poster":_vm.poster,"src":_vm.src,"controls":"","controlslist":"nodownload"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }